let authToken = null;
    async function getAuthToken(customerId, customerEmail) {
        if (authToken) {
            return authToken;
        }
        if (!customerId || !customerEmail) {
            return null;
        }
        
           const reqDatas = {
        email: customerEmail,
        customerId: customerId
        };
        
        try {
            const tokenRes = await fetch(BTPRO_API.GET_TOKEN, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(reqDatas)
            });
            const tokenResponseJson = await tokenRes.json();
            if (tokenResponseJson.succeeded && tokenResponseJson.data && tokenResponseJson.data.token) {
                authToken = tokenResponseJson.data.token;
                return authToken;
            } else {
                console.error("Token alma başarısız: ", tokenResponseJson.messages || "Bilinmeyen hata");
                return null;
            }
        } catch (e) {
            console.error("Token alırken hata oluştu:", e);
            return null;
        }
    }

document.addEventListener('alpine:init', () => {
  Alpine.data('Pdp', () => ({
      init(){

        const customerId = window.theme.holly.customerIdPdp;
        const customerEmail = window.theme.holly.customerEmailPdp;

           // Kullanıcı login ise kendi favori durumunu kontrol et
           if (customerId && customerId !== 'null') {
               this.checkUserFavoriteStatus(customerId, customerEmail);
           }

        // this.getFavDetail();
        const isMobile = window.innerWidth < 767
        this.$watch('pdpDrawerSelectedTab', val => {
          if(val){
            document.body.style.overflow = 'hidden'
            isMobile ? null : document.body.style.paddingRight = '15px'
            document.querySelector('main').classList.add('main-zindex')
          } else {
            document.body.style.overflow = 'auto'
            isMobile ? null : document.body.style.paddingRight = 0
            document.querySelector('main').classList.remove('main-zindex')
          }
        })
        this.$watch('showCampaign', val => {
          if(val){
            document.body.style.overflow = 'hidden'
            isMobile ? null : document.body.style.paddingRight = '15px'
            document.querySelector('main').classList.add('main-zindex')
          } else {
            document.body.style.overflow = 'auto'
            isMobile ? null : document.body.style.paddingRight = 0
            document.querySelector('main').classList.remove('main-zindex')
          }
        })
        this.$watch('showCampaign1', val => {
          if(val){
            document.body.style.overflow = 'hidden'
            isMobile ? null : document.body.style.paddingRight = '15px'
            document.querySelector('main').classList.add('main-zindex')
          } else {
            document.body.style.overflow = 'auto'
            isMobile ? null : document.body.style.paddingRight = 0
            document.querySelector('main').classList.remove('main-zindex')
          }
        })
        this.$watch('kampanyaModal', val => {
          if(val){
            document.body.style.overflow = 'hidden'
            isMobile ? null : document.body.style.paddingRight = '15px'
            document.querySelector('main').classList.add('main-zindex')
          } else {
            document.body.style.overflow = 'auto'
            isMobile ? null : document.body.style.paddingRight = 0
            document.querySelector('main').classList.remove('main-zindex')
          }
        })
        this.$watch('showCampaign2', val => {
          if(val){
            document.body.style.overflow = 'hidden'
            isMobile ? null : document.body.style.paddingRight = '15px'
            document.querySelector('main').classList.add('main-zindex')
          } else {
            document.body.style.overflow = 'auto'
            isMobile ? null : document.body.style.paddingRight = 0
            document.querySelector('main').classList.remove('main-zindex')
          }
        })
        this.$watch('showLikeCampaign', val => {
          if(val){
            document.body.style.overflow = 'hidden'
            isMobile ? null : document.body.style.paddingRight = '15px'
            document.querySelector('main').classList.add('main-zindex')
          } else {
            document.body.style.overflow = 'auto'
            isMobile ? null : document.body.style.paddingRight = 0
            document.querySelector('main').classList.remove('main-zindex')
          }
        })
      },
      pdpDrawerSelectedTab: null,
      selectedDrawerTitle: '',
      totalFavoriteCount: -1,
      isFavorited: false,
      showCampaign: false,
      showCampaign1: false,
      showCampaign2: false,
      showLikeCampaign: false,
      kampanyaModal: false,
      isInstallmentLoading: true,
      installmentData: [],
 
       checkUserFavoriteStatus: async function(customerId, customerEmail){
              if (!customerId) {
                  this.isFavorited = false;
                  return;
              }
              
              const token = await getAuthToken(customerId, customerEmail);
              if (!token) {
                  this.isFavorited = false;
                  return;
              }
              try {
                  const res = await fetch(BTPRO_API.GET_FAVS, {
                      method: "GET",
                      headers: {
                          "Content-Type": "application/json",
                          "Authorization": `Bearer ${token}`
                      },
                  });
                  const fetchResponse = await res.json();
                  if (fetchResponse.succeeded && fetchResponse.data) {
                      const favorites = fetchResponse.data;
                      const currentProductId = window.theme.holly.productId;
                      const currentVariantId = window.theme.holly.variantId;
                      const isProductInFavorites = favorites.some(item =>
                          item.shopifyProductId.split('/').pop() == currentProductId &&
                          item.shopifyProductVariantId.split('/').pop() == currentVariantId
                      );
                      this.isFavorited = isProductInFavorites;
                      
                  } else {
                      this.isFavorited = false;
                  }
              } catch (e) {
                  console.warn("checkUserFavoriteStatus hatası: ", e);
                  this.isFavorited = false;
              }
          },


      // getFavDetail(){
      //   const body = {
      //     CustomerTargetUniqueId : window.theme.holly.customerIdPdp ? +window.theme.holly.customerIdPdp : 1,
      //     ProductVariantTargetUniqueId : +window.theme.holly.variantId,
      //     CorporateCountry : 5,
      //     ProductTargetUniqueId : +window.theme.holly.productId
      //   }
      //   // if(!window.theme.holly.customerIdPdp) delete body.CustomerTargetUniqueId
      //   fetch(HC_API.GET_FAV_DETAIL, {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json'
      //     },
      //     body: JSON.stringify(body)
      //   })
      //   .then(res => res.json())
      //   .then(result => {
      //     const parsedData = JSON.parse(result.data.body)
      //     if(parsedData.isSuccess){
      //       this.totalFavoriteCount = parsedData.data.totalFavoriteCount
      //       this.isFavorited = window.theme.holly.customerIdPdp ? parsedData.data.isFavorite : false
      //     } else {
      //       console.warn('No favorite detail')
      //     }
      //   })
      // },

      handleClickFav(){
        if(!window.theme.holly.customerIdPdp) return
        if(this.isFavorited){
            this.totalFavoriteCount--
          } else {
            this.totalFavoriteCount++
          }
          this.isFavorited = !this.isFavorited
      },
    getProductInstallment(){
          const sessionData = this.getSession('installment_w/varId_' + window.theme.holly.variantId);
          if(sessionData){
            this.installmentData = sessionData;
            this.isInstallmentLoading = false;
          } else {
            const reqUrl = BTPRO_API.GET_INSTALLMENT + '?price=' + window.theme.holly.totalPrice;
            fetch(reqUrl, {
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            })
            .then((response) => response.json())
            .then((res) => {
              if(!res.succeeded || !res.data) return
                const parsedData = res.data
                if(parsedData){
                  const dataWithImages = this.addCardBrandImages(parsedData);
                  const uniqueCards = this.getUniqueCardBrandsWithMaxInstallments(dataWithImages);
                  this.installmentData = uniqueCards;
                  this.setSession('installment_w/varId_' + this.currentVariantId, this.installmentData)
                } else {
                  console.warn('No installment')
                }
                this.isInstallmentLoading = false
            })
            .catch(e => console.error('Sunucu Hatası: ', e))
          }
        },
        getUniqueCardBrandsWithMaxInstallments(data){
  let dataArray = Array.isArray(data) ? data : (data.data || []);
  const cardBrandMap = {};
  dataArray.forEach(item => {
    const installmentCount = item.installmentPrices?.length || 0;
    if(!cardBrandMap[item.cardBrand] || 
       cardBrandMap[item.cardBrand].installmentPrices.length < installmentCount){
      cardBrandMap[item.cardBrand] = item;
    }
  });
  const uniqueCards = Object.values(cardBrandMap);
  uniqueCards.sort((a, b) => {
    return (b.installmentPrices?.length || 0) - (a.installmentPrices?.length || 0);
  });
  return uniqueCards;
},
        addCardBrandImages(data){
          if(Array.isArray(data)){
            return data.map(item => ({
              ...item,
              cardBrandPictureUrl: this.getCardBrandImageUrl(item.cardBrand)
            }));
          }
          return data;
        },
       getCardBrandImageUrl(cardBrand){
        const imageMap = {
          'Maximum': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/maximum.png?v=1760685394',
          'Bankkart Combo': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/bankkart.png?v=1760685394',
          'World': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/world.png?v=1760685395',
          'Paraf': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/paraf.png?v=1760685394',
          'Bonus': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/bonus.png?v=1760685395',
          'Axess': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/axess.png?v=1760685394',
          'CardFinans': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/cardfinans.png?v=1760685395',
          'Advantage': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/advantage.png?v=1760685394',
          'Sağlam Kart': 'https://cdn.shopify.com/s/files/1/0598/6798/8046/files/saglamkart.png?v=1760685395'
        };
        
        return imageMap[cardBrand] || '';
      },
      setSession(key, value) {
        sessionStorage.setItem(key, JSON.stringify(value));
      },
      getSession(key) {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : null;
      },
      handleSelectTab(category){
        this.pdpDrawerSelectedTab = category
        switch(category){
          case 'info':
            this.selectedDrawerTitle = 'Ürün Bilgileri'
          break
          case 'campaigns':
            this.selectedDrawerTitle = 'Kampanyalar'
          break
          case 'reviews':
            this.selectedDrawerTitle = 'Yorumlar'
          break
          case 'store':
            this.selectedDrawerTitle = 'Hangi Mağazada Var?'
          break
          case 'installment':
            this.selectedDrawerTitle = 'Taksit Seçenekleri'
          break
          case 'conditions':
            this.selectedDrawerTitle = 'İade, İptal ve Teslimat Koşulları'
          break
          default:
            this.selectedDrawerTitle = 'Ürün Bilgileri'
        }
      },
      formatter: new Intl.NumberFormat('tr-TR', {
        style: 'currency',
        currency: 'TRY',
        minimumFractionDigits: 2,
      }),
  }))
})